import { Helmet } from 'react-helmet-async';
import { Header } from '@/components/layout/Header';
import { WelcomeSection } from '@/components/sections/WelcomeSection';
import { ImageGallery } from '@/components/sections/ImageGallery';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { CompanyInfoSection } from '@/components/sections/CompanyInfoSection';
import { Footer } from '@/components/layout/Footer';

export function Index() {

  return (
    <>
      <Helmet>
        <title>Thoroughbred Aviation Maintenance – Mobile and on-site parts and maintenance</title>
        <meta name="description" content="Providing mobile and on-site aviation maintenance and parts. Locations at Danville, Somerset, Georgetown, Richmond, Lexington, and Big Sandy Airports." />
        <meta name="keywords" content="aviation maintenance, helicopter maintenance, aircraft parts, avionics, painting, AOG service" />
        <meta name="robots" content="max-image-preview:large" />
        <link rel="canonical" href="https://thoroughbredaviationmaintenance.com/" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://thoroughbredaviationmaintenance.com/" />
        <meta property="og:title" content="Thoroughbred Aviation Maintenance – Mobile and on-site parts and maintenance" />
        <meta property="og:description" content="Providing mobile and on-site aviation maintenance and parts. Locations at Danville, Somerset, Georgetown, Richmond, Lexington, and Big Sandy Airports." />
        <meta property="og:site_name" content="Thoroughbred Aviation Maintenance" />
        
        {/* Twitter Card */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://thoroughbredaviationmaintenance.com/" />
        <meta property="twitter:title" content="Thoroughbred Aviation Maintenance – Mobile and on-site parts and maintenance" />
        <meta property="twitter:description" content="Providing mobile and on-site aviation maintenance and parts. Locations at Danville, Somerset, Georgetown, Richmond, Lexington, and Big Sandy Airports." />
        
        {/* Additional SEO */}
        <html lang="en-US" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <main>
          <WelcomeSection />
          <ImageGallery />
          <ServicesSection />
          <CompanyInfoSection />
        </main>
        
        <Footer />
      </div>
    </>
  );
}